import React, { createContext, ReactElement, ReactNode, useContext, useState } from 'react';
import Dialog from 'react-bootstrap-dialog';
import { BiCheckCircle, BiError, BiErrorAlt, BiInfoCircle } from 'react-icons/all';

const DialogContext = createContext<Dialog | null>(null);

export function DialogProvider({ children }: { children: ReactNode }): ReactElement {
    const [refDialog, setRefDialog] = useState<Dialog | null>(null);
    return (
        <DialogContext.Provider value={refDialog}>
            <Dialog ref={setRefDialog} />
            {children}
        </DialogContext.Provider>
    );
}

export function useDialog(): Dialog {
    return (useContext(DialogContext) as unknown) as Dialog;
}

const iconSize = '1.25em';

const icons = {
    info: <BiInfoCircle className="text-info" size={iconSize} />,
    warning: <BiError className="text-warning" size={iconSize} />,
    danger: <BiErrorAlt className="text-danger" size={iconSize} />,
    success: <BiCheckCircle className="text-success" size={iconSize} />,
};

export function useAlertDialog(): (
    msg: ReactElement | string,
    variant?: null | 'warning' | 'danger' | 'info' | 'success',
    bsSize?: 'medium' | 'lg' | 'sm',
    onConfirm?: () => void,
) => void {
    const dialog = useDialog();
    return (
        msg: ReactElement | string,
        variant: null | 'warning' | 'danger' | 'info' | 'success' = null,
        bsSize: 'medium' | 'lg' | 'sm' = 'medium',
        onConfirm?: () => void,
    ) => {
        const body = (
            <div className="d-flex">
                {variant ? (
                    <div className="pr-3">
                        <h1 className="d-flex align-items-start m-0">{icons[variant]}</h1>
                    </div>
                ) : null}
                <div className="align-self-center">{msg}</div>
            </div>
        );
        dialog.show({
            title: 'Alert',
            body: body,
            actions: [
                Dialog.OKAction(() => {
                    if (onConfirm) {
                        onConfirm();
                    }
                }),
            ],
            bsSize: (bsSize as unknown) as undefined,
        });
    };
}
